import Req from '../../$axios';

const serviceModule = {
  // 模板列表
  getprojectTemplate(params) {
    return Req({
      url: 'tasks/templates/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 新增当前模板key
  updateTemplateInfo(params) {
    return Req({
      url: 'tasks/templates/update',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取所有组件
  getAllComponent(params) {
    return Req({
      url: 'standardComponents/index',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  // 获取模板详情
  getTemplateDetail(params) {
    return Req({
      url: 'tasks/templates/read',
      method: 'get',
      isJSON: false,
      tip: false,
      isAlertErr: true,
    }, params);
  },
  //更新模板内标准件的其他内容(顺序或是否展示)
  updateTemplateStandardComponentOtherContent(params) {
    return Req({
      url: 'tasks/templates/updateTemplateStandardComponentOtherContent',
      method: 'post',
      isJSON: true,
      tip: false,
      isAlertErr: true,
    }, params);
  }
};

export default {
  ...serviceModule
};
